/* eslint-disable max-len */
import React from 'react';
import CommonModal from '../../../../components/Modal';
import FormatDateString from '../../../../CommonMethods/FromatDateString';

const formatDateLabel = (holidayItem) => {
    if (holidayItem?.holiday_date_range) {
        const [startDate, endDate] = String(holidayItem.holiday_date_range).split(' to ');
        if (startDate && endDate) {
            const formattedStartDate = FormatDateString(startDate);
            const formattedEndDate = FormatDateString(endDate);
            return startDate === endDate ? formattedStartDate : `${formattedStartDate} to ${formattedEndDate}`;
        }
        return holidayItem.holiday_date_range;
    }

    if (holidayItem?.holiday_date) {
        return FormatDateString(holidayItem.holiday_date);
    }

    return '-';
};

const getHolidayNames = (holidayItem) => {
    if (holidayItem?.holiday_name) {
        return holidayItem.holiday_name;
    }

    return (holidayItem?.date_holidays || [])
        .map((holiday) => holiday?.name)
        .filter(Boolean)
        .join(', ');
};

export default function HolidayListDialog({ open, onClose, holidayList = [], viewLabel = '', currentMonth = '', currentYear = '' }) {
    const monthLabel = currentMonth ? `; ${currentMonth}${currentYear ? ` ${currentYear}` : ''}` : '';

    return (
        <CommonModal
            show={open}
            handleClose={onClose}
            title="Holiday List"
            dialogueWidth="680px"
            dialogueHeight="fit-content"
            dialogTopOffset={10}
        >
            <div className="px-4 pb-4">
                {viewLabel && (
                    <p id="compare-text" className="mb-3 w-full font-normal text-[#031624]">
                        <span>Viewing holidays for - </span>
                        <span className="font-semibold">{viewLabel}{monthLabel}</span>
                    </p>
                )}
                {holidayList.length === 0 ? (
                    <div className="py-8 text-center">
                        No holidays found for the selected filters.
                    </div>
                ) : (
                    <div className="max-h-[65vh] overflow-y-auto scroll-bar" id="search-result">
                        <table className="w-full" id="admin-table">
                            <thead className="sticky top-0">
                                <tr>
                                    <th className="w-[25%]">
                                        <span>Date</span>
                                    </th>
                                    <th className="w-[50%]">
                                        <span>Holiday Name(s)</span>
                                    </th>
                                    <th className="w-[25%]">
                                        <span>Holiday Type</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {holidayList.map((holidayItem, index) => (
                                    <tr key={holidayItem?.date_range_id || holidayItem?.holiday_date_range || holidayItem?.holiday_date || holidayItem?.date || index} >
                                        <td className="">
                                            {formatDateLabel(holidayItem)}
                                        </td>
                                        <td className="">
                                            {getHolidayNames(holidayItem) || '-'}
                                        </td>
                                        <td className="">
                                            {holidayItem?.holiday_type || '-'}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </CommonModal>
    );
}
